<template>
	<section class="blog-home sec-padding" style="background: rgb(247, 247, 247) !important;">
		<div class="container">
			<div class="sec-title text-center">
				<h2>最新动态</h2>
				<p>普及种子科学知识，总结、推广种子工作先进经验，促进种子产业健康持续发展。</p>
				<span class="decor">
				<span class="inner"></span>
				</span>
			</div>
			<div class="row hot-news">
				<div v-for="item in data" class="col-md-3 col-sm-12 sm-col5-center mb-sm-40">
					<div class="single-blog-post">
						<div class="img-box" @click="detail(item)">
							<img v-lazy="item.news_img" alt="">
							<div class="overlay">
								<div class="box">
									<div class="content">
										<ul>
											<li>
												<a href="javascript:void(0);"><i class="fa fa-link"></i></a>
											</li>
										</ul>
									</div>
								</div>
							</div>
						</div>
						<div class="content-box">
							<div class="date-box">
								<div class="inner">
									<div class="date">
										<b>{{item.formateDay}}</b> {{item.formateMonth}}月
									</div>
								</div>
							</div>
							<div class="content">
								<a href="javascript:void(0);">
									<h3>{{item.news_title}}</h3>
								</a>
								<p>{{item.news_intro}}</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
	import tmp from "@/assets/js/tmp.js";
	export default {
		name: "trends",
		props: ['data'],
		data(){
			return{
				list: tmp.home.news
			}
		},
		methods:{
			detail(item){
				// let href = window.location.href.split("#")[0];
				// href += "#/newsDetail/"+ item.id
				// window.open(href);
				this.$router.push({
					name: 'newsDetail',
					params: {
						id: item.id
					}
				});
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/home/Trends.vue